import React from 'react';
import { useRef } from 'react';
import { connectInfiniteHits } from 'react-instantsearch-dom';

import './SearchBarHits.scss';
import { ALL_DOCS } from '../../utils/constants';
import { ActualPageProps } from '../../entities/Page';
import SearchBarHit from './SearchBarHit';
import { LIMIT_HITS_PANEL } from './SearchBar';

interface SearchBarHitsProps {
  hits: any;
  hasMore: boolean;
  saveRecentSearch: (val: any) => void;
  selectedPanelItem: number;
  setSelectedPanelSlug: (val: string) => void;
  actualPage: ActualPageProps;
  selectedPage: string;
  resourceSelected: number;
  setHasResource: (val: string) => void;
  hasResource: string | null;
  setLimitResourceHits: (val: any) => void;
  setLimitHitsPanel: (val: any) => void;
  limitHitsPanel: number;
}

const SearchBarHits = ({
  hits,
  saveRecentSearch,
  selectedPanelItem,
  setSelectedPanelSlug,
  actualPage,
  selectedPage,
  resourceSelected,
  setHasResource,
  hasResource,
  setLimitHitsPanel,
  setLimitResourceHits,
  limitHitsPanel,
}: SearchBarHitsProps) => {
  const ref = useRef();

  if (hits.length < 7) {
    setLimitHitsPanel(hits.length);
  } else {
    setLimitHitsPanel(7);
  }

  const noTutorials = hits.filter((allHits) =>
    actualPage.title === selectedPage && selectedPage !== ALL_DOCS
      ? selectedPage === 'Hardware'
        ? allHits.slug?.split('/')[1] === actualPage.url.replace(/(^\/+|\/+$)/gm, '') || allHits.slug?.split('/')[1] === 'tutorials'
        : allHits.slug?.split('/')[1] === actualPage.url.replace(/(^\/+|\/+$)/gm, '')
      : allHits
  ).length;

  if (noTutorials === 0) {
    setSelectedPanelSlug(null);
  }

  return (
    <>
      {hits
        .filter((allHits) =>
          actualPage.title === selectedPage && selectedPage !== ALL_DOCS
            ? selectedPage === 'Hardware'
              ? allHits.slug?.split('/')[1] === actualPage.url.replace(/(^\/+|\/+$)/gm, '') || allHits.slug?.split('/')[1] === 'tutorials'
              : allHits.slug?.split('/')[1] === actualPage.url.replace(/(^\/+|\/+$)/gm, '')
            : allHits
        )
        .map((hit, i) => {
          return i < LIMIT_HITS_PANEL ? (
            <SearchBarHit
              setSelectedPanelSlug={setSelectedPanelSlug}
              index={i}
              hit={hit}
              key={hit.slug}
              saveRecentSearch={saveRecentSearch}
              selectedPanelItem={selectedPanelItem}
              resourceSelected={resourceSelected}
              setHasResource={setHasResource}
              hasResource={hasResource}
              setLimitResourceHits={setLimitResourceHits}
            />
          ) : null;
        })}
      {(hits.length === 0 || noTutorials === 0) && <span className="search-hits__no-tutorials">There are no results that match the search.</span>}
      {hits && <div style={{ width: '100%' }} ref={ref}></div>}
    </>
  );
};

export default connectInfiniteHits(SearchBarHits);
